import page from './Text.vue';
export default page;


// WEBPACK FOOTER //
// ./src/components/page/text/index.js